var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f-wrapper',{attrs:{"page":"recovery"}},[_c('f-login-container',[_c('h1',[_vm._v(_vm._s(_vm.$tt.capitalize(_vm.$t('loginPage.pages.recovery.title'))))])]),_c('f-card',[_c('f-recovery-form')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }